import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-header",
  id: "main-header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "logo",
  href: "#"
}, " 宁波华标检测信息管理系统 ", -1)
const _hoisted_3 = { class: "navbar navbar-static-top" }
const _hoisted_4 = {
  class: "navbar-custom-menu",
  id: "navbar-custom-menu-right"
}
const _hoisted_5 = { class: "nav navbar-nav" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-out" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("退出")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.changeEvent && $options.changeEvent(...args)))
            }, _hoisted_8)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = (...args) => ($options.signOut && $options.signOut(...args)))
            }, _hoisted_11)
          ])
        ])
      ])
    ])
  ]))
}